import { render, staticRenderFns } from "./AdminLocalityView.vue?vue&type=template&id=23873baa&"
import script from "./AdminLocalityView.vue?vue&type=script&lang=js&"
export * from "./AdminLocalityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports